module.exports = __webpack_public_path__ + "img/DE04042.4191e479.png";